// chill-view-transitions: shared element morph product card → PDP gallery.
//
// Sprint 2.5 polish. Pairs with chill-view-transitions.css.
// Cross-document View Transitions are CSS-driven (just `@view-transition`),
// but the SHARED element name needs to be applied at click-time so the
// browser picks up the right view-transition-name pair.
//
// On click of a chill-product-card link, this module:
//   1. Reads the card's product ID
//   2. Sets `view-transition-name: chill-product-{id}` on the card image
//   3. After navigation, the PDP gallery's first image picks up the
//      matching name (set via data-product-vt-hero attribute in product
//      template, written client-side here too as a fallback)
//
// Falls through silently when View Transitions API is unsupported.
//
// Budget: < 0.6 KB gzip. No deps.

(function () {
  'use strict';

  if (window.chillandoutVTLoaded) return;
  window.chillandoutVTLoaded = true;
  if (!('startViewTransition' in document) && !CSS.supports?.('view-transition-name', 'foo')) {
    return; // unsupported — bail
  }
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const VT_NAME = 'product-hero';

  // On click, mark the card's image with a view-transition-name. The CSS
  // pairs this with the PDP gallery image's name automatically.
  function onCardClick(e) {
    const link = e.target.closest('chill-product-card a[href*="/products/"]');
    if (!link) return;
    const card = link.closest('chill-product-card');
    if (!card) return;
    const img = card.querySelector('.chill-card__image--primary');
    if (!img) return;
    // Assign the morph name. Use a unique-per-product name so multiple
    // cards on the page don't conflict.
    const productId = card.dataset.productId || 'shared';
    const name = 'chill-product-' + productId;
    img.style.setProperty('--chill-vt-name', name);
    img.setAttribute('data-vt-name', '');
    // Persist the name in sessionStorage so the PDP can pick it up.
    try {
      sessionStorage.setItem('chillandout:vt:product-name', name);
      sessionStorage.setItem('chillandout:vt:product-id', String(productId));
    } catch { /* skip */ }
  }

  document.addEventListener('click', onCardClick, true);

  /* ---------- PDP side: tag gallery image with the morph name ---------- */

  function tagPdpGallery() {
    let stored = '';
    let storedId = '';
    try {
      stored = sessionStorage.getItem('chillandout:vt:product-name') || '';
      storedId = sessionStorage.getItem('chillandout:vt:product-id') || '';
    } catch { return; }
    if (!stored) return;
    // Verify the stored name matches the current product (defensive: if
    // user navigated elsewhere first, don't morph).
    const currentId = (document.querySelector('[data-product-id]')?.dataset.productId) || '';
    if (storedId && currentId && String(storedId) !== String(currentId)) {
      // Different product — clear stored state.
      try { sessionStorage.removeItem('chillandout:vt:product-name'); } catch {}
      return;
    }
    const img = document.querySelector(
      'media-gallery img, .media-gallery__grid img, .product-media-gallery img, .product-media img'
    );
    if (!img) return;
    img.style.setProperty('--chill-vt-name', stored);
    img.setAttribute('data-product-vt-hero', '');
    // Clear after applying — only first navigation gets the morph.
    setTimeout(() => {
      try { sessionStorage.removeItem('chillandout:vt:product-name'); } catch {}
      try { sessionStorage.removeItem('chillandout:vt:product-id'); } catch {}
    }, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tagPdpGallery, { once: true });
  } else {
    tagPdpGallery();
  }
})();
